export enum CompositionEventsEnum {
    LAYER_ADDED = "layer:added",
    LAYER_REMOVED = "layer:removed",
    CLIP_ADDED = "clip:added",
    CLIP_UPDATED = "clip:updated",
    CLIP_REMOVED = "clip:removed",
    SCRIPT_LAYER_UPDATED = "script:updated",
    CANVAS_RESIZED = "canvas:resized",
    CANVAS_BACKGROUND_CHANGED = "canvas:background:changed",
    PLAYBACK_STATE = "playback:state",
    PLAYBACK_TIME = "playback:time",
    COMPOSITION_EMPTY = "composition:empty",
}